import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';

import SmartLibAIPage from '../../../subsreens/gcstudent/smartlibAI/SmartLibAIPage';

const SmartLibAI = () => {
    return(
        <StudentDashboardLayout>
            <SmartLibAIPage></SmartLibAIPage>
        </StudentDashboardLayout>
    )
}

export default SmartLibAI;